import { render } from "./TariffsIndividualSparkKzCreate.vue?vue&type=template&id=73cf73c2&scoped=true&ts=true"
import script from "./TariffsIndividualSparkKzCreate.vue?vue&type=script&lang=ts"
export * from "./TariffsIndividualSparkKzCreate.vue?vue&type=script&lang=ts"

import "./TariffsIndividualSparkKzCreate.vue?vue&type=style&index=0&id=73cf73c2&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cf73c2"]])

export default __exports__